<template>
  <div class="device-query">
    <query-form :config="['产品名称', '生产者账号', '串号', '通信编号']" @fetch-data="fetchData"></query-form>

    <count-total :total="total"></count-total>

    <my-list :btnConfig="['查看二维码', '查看证书', '查看文件', '修改配置', '删除']" :dataSource="dataSource" :loading="loading" :flag="flag" :search="search"></my-list>
  </div>
</template>

<script>
import { queryDevicesAllInfo } from '../../api/api'

export default {
  name: 'device-query',

  data() {
    return {
      dataSource: [],
      loading: false,
      total: 0,
      flag: true,
      search: {
        productID: '',
        producerUsername: '',
        serialNumber: '',
        current: 1,
        size: 10
      }
    }
  },

  created() {
    // this.fetchData()
  },

  methods: {
    fetchData(params) {

      if (params && params.isQuery) {
        this.dataSource = []
      }

      const para = {
        keys: {
          productID: params ? params.productID || '' : '',
          producerUsername: params ? params.producerUsername || '' : '',
          serialNumber: params ? params.serialNumber || '' : '',
          communicationSerialNo: params ? params.communicationSerialNo || '' : '',
        },
        page: {
          size: params.size,
          current: params.current
        }
      }

      this.search = params
      this.loading = true
      queryDevicesAllInfo(para)
        .then(res => {
          if (res.error.code === 0) {
            this.total = res.response.total

            if (res.response.records.length < params.size) {
              this.flag = false
            } else {
              this.flag = true
            }

            this.dataSource = this.dataSource.concat(res.response.records)
            this.loading = false

          } else {
            this.dataSource = []
            this.loading = false
          }
        })
    }
  }
}
</script>

